import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import FormField from '../../../utils/InputField';

const FormSection = ({
  section,
  isExpanded,
  onToggle,
  formData,
  onInputChange,
  isEditable,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow duration-300">
      {/* Section Header */}
      <button
        onClick={onToggle}
        className="w-full px-6 py-4 flex items-center justify-between bg-gradient-to-r from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 border-b-2 border-blue-500 transition-colors duration-300"
      >
        <h2 className="text-xl font-bold text-gray-800" style={{ fontFamily: 'Montserrat' }}>
          {section.title}
        </h2>
        <div className="text-blue-600">
          {isExpanded ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
        </div>
      </button>

      {/* Section Content */}
      {isExpanded && (
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {section.fields.map((field) => (
              <div
                key={field.name}
                className={field.type === 'textarea' ? 'md:col-span-2' : ''}
              >
                <FormField
                  field={field}
                  value={formData[field.name]}
                  onChange={onInputChange}
                  isEditable={isEditable}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FormSection;